import InboxOutlined from '@mui/icons-material/InboxOutlined';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

export function NoData({
  message = 'No data for the selected filters.',
}: {
  message?: string;
}): ReactNode {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        py: 6,
        px: 3,
        textAlign: 'center',
      }}
    >
      <InboxOutlined sx={{ fontSize: 28, color: 'text.disabled' }} />
      <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'text.secondary' }}>
        {message}
      </Typography>
    </Box>
  );
}
